export default [
  {
    id: "ART",
    summary: 'En proceso',
    detail: 'En proceso de reenvío',
    color: 'yellow-100',
    icon: 'mdi-sync'
  },
  {
    id: "PEN",
    summary: 'Pendiente',
    detail: 'Pendiente',
    color: 'yellow-100',
    icon: 'mdi-clock'
  },
  {
    id: "FAI",
    summary: 'Pendiente',
    detail: 'Pendiente',
    color: 'yellow-100',
    icon: 'mdi-clock'
  },
  {
    id: "CRE",
    summary: 'Pendiente',
    detail: 'Pendiente',
    color: 'yellow-100',
    icon: 'mdi-clock'
  },
  {
    id: "REJ",
    summary: 'Rechazado',
    detail: 'Rechazado',
    color: 'red-100',
    icon: 'mdi-close-circle-outline'
  },
  {
    id: "VOI",
    summary: 'Anulada',
    detail: 'Anulada',
    color: 'grey-200',
    icon: 'mdi-file-document-remove'
  },
  {
    id: "ASI",
    summary: 'Aceptada',
    detail: 'Aceptada',
    color: 'blue-100',
    icon: 'mdi-check-circle-outline'
  },
  {
    id: "UNK",
    summary: 'Fallida',
    detail: 'Fallida',
    color: 'red-100',
    icon: 'mdi-alert-circle-outline'
  },
  {
    id: "ERR",
    summary: 'Error',
    detail: 'Error',
    color: 'red-100',
    icon: 'mdi-alert-circle-outline'
  }
]
